'use client';

/**
 * 상세 다이얼로그가 연 광고의 원본 문서 — 목록이 받지 않는 AI 판별(소구 고민 · 클레임 · 추정 타겟 · 판별 근거 · 오퍼 유형 등)을 채운다.
 *
 * 광고 화면 상세와 같은 질문(`ads.detail`)이다. 광고 카드를 열었을 때만 묻고, 한 번 받은 광고는 캐시로 다시 묻지 않는다.
 */

import { useQuery } from '@tanstack/react-query';

import { fetchAdDetail } from 'src/actions/els/ads-meta';
import { searchAllKeys } from 'src/query-keys/search-all';

const STALE_MS = 10 * 60 * 1000;

/** @param adId 열린 광고 id(adArchiveId) — 광고가 아니면 빈 문자열 */
export function useSearchAllAdDetail(adId: string): { doc: Record<string, unknown> | null; loading: boolean } {
  const res = useQuery({
    queryKey: searchAllKeys.adDetail(adId),
    enabled: adId.length > 0,
    staleTime: STALE_MS,
    queryFn: async () => (await fetchAdDetail({ adId })).esDoc,
  });
  return { doc: adId ? res.data ?? null : null, loading: adId.length > 0 && res.isPending };
}
